import axios from "axios";
import { Constants, CookieService, Utils } from "../../../shared";

export const SystemParametersService = {

    /**
     * Fetch system parameters from the API.
     * @returns {Promise} The promise object representing the API call.
     */
    fetchSystemParameters: () => {
        return axios.get(Constants.ClientConfigurationUrl, {
            params: {
                "partition-key": "client_id",
                "partition-value": Utils.getRouteParam("clientid")?.toUpperCase()
            },
            headers: { ansid: CookieService.getCookie("ANsid") }
        })
            .then((response) => {
                return response?.data?.Items?.filter(item => item?.mo_agency_id || item?.mo_organization_id)
            })
    },

    /**
     * Add/Update system parameters in the API.
     * @param {Object} payload - The data to be updated.
     * @returns {Promise} The promise object representing the API call.
     */
    addOrUpdateSystemParameters: (payload) => {
        return axios.post(Constants.ClientConfigurationUrl,
            payload,
            {
                headers: { ansid: CookieService.getCookie("ANsid") },
                params: { date: true }
            })
            .then((response) => {
                return response
            })
    }
}